import { BCPAssessmentData, PackageRecommendation, UserPreferences } from '../types/userPreferences';
import { getAccessToken } from '../utils/authToken';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class UserPreferencesService {
  private getAuthHeaders() {
    const token = getAccessToken();
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  async submitAssessment(assessment: BCPAssessmentData): Promise<PackageRecommendation> {
    const response = await fetch(`${API_BASE_URL}/v1/user-preferences/assessment`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(assessment)
    });

    if (!response.ok) {
      throw new Error('Failed to submit assessment');
    }

    return response.json();
  }

  async getUserPreferences(): Promise<UserPreferences | null> {
    const response = await fetch(`${API_BASE_URL}/v1/user-preferences/`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    if (response.status === 404) {
      return null; // No preferences found
    }

    if (!response.ok) {
      throw new Error('Failed to get user preferences');
    }

    return response.json();
  }

  async updateUserPreferences(preferences: Partial<UserPreferences>): Promise<UserPreferences> {
    const response = await fetch(`${API_BASE_URL}/v1/user-preferences/`, {
      method: 'PUT',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(preferences)
    });

    if (!response.ok) {
      throw new Error('Failed to update user preferences');
    }

    return response.json();
  }

  async deleteUserPreferences(): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/v1/user-preferences/`, {
      method: 'DELETE',
      headers: this.getAuthHeaders()
    });

    if (!response.ok) {
      throw new Error('Failed to delete user preferences');
    }
  }
}

export const userPreferencesService = new UserPreferencesService();
